import '../App.css';
import {FiArrowUpCircle} from "react-icons/fi";

function BackToTopButton() {
    const handleScrollTop = () => {window.scrollTo({top: 0, behavior: 'smooth'})};
    return (
        <div className="BackToTopButton" onClick={handleScrollTop}>
            <FiArrowUpCircle/>
        </div>
    )
}

export default BackToTopButton;